
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import AuditService from '@/services/audit.service';
import { EShopField, EShopBusinessPOI } from '@/common/enum/shop';
import ShopService from '@/services/shop.service';

@Component({})
export default class ChangePoiModal extends Vue {
  visible = false;

  @Prop()
  shopId?: string | number;

  @lazyInject(ShopService)
  protected shopService!: ShopService;

  @lazyInject(AuditService)
  protected auditService!: AuditService;

  EShopField = EShopField;

  EShopBusinessPOI = EShopBusinessPOI;

  EShopType = '';

  title = '';

  poi = '';

  atagName: any = '';

  init(val: any) {
    console.log(val);
    this.title = val;
    this.EShopType = val;
    this.poi = '';
    this.visible = true;
  }

  handleOk() {
    if (!this.poi) {
      this.$message.error('请输入POI');
      return;
    }
    const params = {
      shop_id: this.shopId,
      poi: this.poi,
    };
    console.log(this.shopId);
    switch (this.EShopType as EShopBusinessPOI) {
      case EShopBusinessPOI.门店迁址:
        this.poiRelocate(params);
        break;
      case EShopBusinessPOI.闭店重开:
        this.poiRecreate(params);
        break;
      case EShopBusinessPOI.同步商家平台POI:
        this.poiUpdate(params);
        break;
      default:
        break;
    }
  }

  async poiRelocate(params: any) {
    const res = await this.shopService.postPoiRelocate(params);
    if (res) {
      this.$message.success('操作成功!');
      this.visible = false;
      this.$emit('update');
    }
  }

  async poiRecreate(params: any) {
    const res = await this.shopService.postPoiRecreate(params);
    if (res) {
      this.$message.success('操作成功!');
      this.visible = false;
      this.$emit('update');
    }
  }

  async poiUpdate(params: any) {
    const res = await this.shopService.postPoiUpdate(params);
    if (res) {
      this.$message.success('操作成功!');
      this.visible = false;
      this.$emit('update');
    }
  }

  handleCancel() {
    this.visible = false;
  }
}
